import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {memoize} from 'decko';
import {saveAs} from 'file-saver/FileSaver';
import {ToasterService} from 'angular2-toaster';
import {TranslateService} from '@ngx-translate/core';
import {BsModalService} from 'ngx-bootstrap';
import {map} from 'rxjs/operators/map';
import {mergeMap, toArray} from 'rxjs/operators';
import {from} from 'rxjs/observable/from';
import {DataChangesObserver, TitleService} from '@common-lib';

import {
    ConfigurationService,
    VariantsService,
    ProductsService,
    CategoriesService,
    SubcategoriesService
} from '../../pages-services';
import {ConfigurationBaseComponent} from '../configuration-base/configuration-base.component';

@Component({
    selector: 'app-configuration-variant-groups',
    templateUrl: './configuration-variant-groups.component.html',
    styleUrls: ['../configuration-base/configuration-base.component.scss','../configuration-variant-groups/configuration-variant-groups.component.scss'],
})

export class ConfigurationVariantGroupsComponent extends ConfigurationBaseComponent implements OnInit {
    resource = 'variant-groups';

    variants = [];
    products = [];
    categories = [];
    subcategories = [];

    variantsById = [];
    productsById = [];
    categoriesById = [];
    subcategoriesById = [];

    selectedVariantsByVariantGroup = [];

    constructor(
        protected title: TitleService,
        protected route: ActivatedRoute,
        protected toasterService: ToasterService,
        protected dataChanges: DataChangesObserver,
        protected translateService: TranslateService,
        protected configurationService: ConfigurationService,
        private modalService: BsModalService,
        private variantsService: VariantsService,
        private productsService: ProductsService,
        private categoriesService: CategoriesService,
        private subcategoriesService: SubcategoriesService
    ) {
        super(title, route, toasterService, dataChanges, translateService, configurationService);
    }

    ngOnInit() {
        this.variantsService.getList(this.selectedLocale)
            .pipe(
                mergeMap(({variants}) => from(variants)),
                mergeMap((variant: any) =>
                    this.translateService.get(variant.title).pipe(map(title => {
                            variant.title = title;
                            return variant;
                        }),
                    )
                ),
                toArray(),
            ).subscribe(variants => {
            this.variants = variants;
            this.variants.forEach(variant => {
                const {id, name, title, products} = variant;
                this.variantsById[id] = {id, name, title, products};
            });
        });

        this.productsService.getList(this.selectedLocale).subscribe(({products}) => {
            products.forEach(product => {
                const {id, title} = product;
                this.productsById[id] = title;
            });
            this.products = products;
        });

        this.categoriesService.getList(this.selectedLocale).subscribe(({categories}) => {
            categories.forEach(category => {
                const {id, title, productId} = category;
                this.categoriesById[id] = {title, productId};
            });
            this.categories = categories;
        });

        this.subcategoriesService.getList(this.selectedLocale).subscribe(({subcategories}) => {
            subcategories.forEach(subcategory => {
                const {id, name, productId} = subcategory;
                this.subcategoriesById[id] = {name, productId};
            });
            this.subcategories = subcategories;
        });

        this.loadItems();
    }

    protected loadItems(): Promise<Object> {
        return new Promise((resolve, reject) => {
            this.configurationService.getList(this.resource, this.selectedLocale).subscribe(({result}) => {
                this.state.variantGroupById = {};
                result.variantGroups = result.variantGroups.map(variantGroup => {
                    const {id, name} = variantGroup;
                    this.state.variantGroupById[id] = {name};
                    variantGroup.variantIds = variantGroup.variants.map(v => v.id);
                    this.selectedVariantsByVariantGroup[id] = variantGroup.variantIds;
                    return variantGroup;
                });
                this.state.items = this.createChangesObservation(result.variantGroups);
                resolve(this.state.items);
            }, error => reject(error));
        });
    }

    @memoize()
    getVariantsDropdownList(variantGroupItem) {
        variantGroupItem = JSON.parse(variantGroupItem);
        let variants = this.variants
            .filter(item => item.subcategoryId === variantGroupItem.subcategoryId || !item.subcategoryId)
            .map(item => {
                item.disabled = false;
                return item;
            });

        this.selectedVariantsByVariantGroup
            .filter((selectedVariantIds, index) => variantGroupItem.id !== index)
            .forEach((selectedVariantIds) => {
                variants = variants.map(item => {
                    if (selectedVariantIds.includes(item.id)) {
                        item.disabled = true;
                    }
                    return item;
                });
            });

        return variants;
    }

    onChangeVariantGroupSubcategory(event, variantGroupItem) {
        if (variantGroupItem.variantIds) {
            const isSubcategoryChanged = variantGroupItem.variantIds.some(variantId => !event.variantIds.includes(variantId));
            if (isSubcategoryChanged) {
                variantGroupItem.variantIds = [];
            }
        }
    }

    onRemoveVariantGroupVariant(event, variantGroupItem) {
        const selectedVariantIndex = this.selectedVariantsByVariantGroup.indexOf(event.value.id);
        delete this.selectedVariantsByVariantGroup[selectedVariantIndex];
    }

    editItem(item) {
        super.editItem(item);

        // reset cache for variants dropdown
        item.timestamp = +new Date();
    }
}


// WEBPACK FOOTER //
// ./src/app/pages/configuration-variant-groups/configuration-variant-groups.component.ts